import React from "react";
import { Link } from "react-router-dom";
import { API } from "@/lib/api";
import { BadgeCheck, TrendingUp } from "lucide-react";
import FavoriteButton from "@/components/FavoriteButton";
import SmartImage from "@/components/SmartImage";
import { useAuth } from "@/context/AuthContext";

export default function BookCard({ book, index = 0, purchasedCount = 0 }) {
  const cover = book.cover_url || (book.cover_path ? `${API}/files/${book.cover_path}` : null);
  const { user } = useAuth();
  return (
    <div className="relative group animate-fade-up" style={{ animationDelay: `${index * 70}ms` }}>
      {user && user !== false && (
        <div className="absolute top-3 right-3 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
          <FavoriteButton bookId={book.id} bookTitle={book.title} />
        </div>
      )}
      <Link
        to={`/book/${book.id}`}
        data-testid={`book-card-${book.id}`}
        className="block"
      >
      <div className="aspect-[3/4] bg-linen overflow-hidden relative book-card-cover">
        {cover ? (
          <SmartImage
            src={cover}
            alt={book.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-serif text-3xl text-muted_ink p-6 text-center">
            {book.title}
          </div>
        )}
        {book.shop_owned && (
          <div
            data-testid={`badge-shop-${book.id}`}
            className="absolute top-3 left-3 bg-paper/95 backdrop-blur-sm px-2 py-1 flex items-center gap-1 text-[10px] uppercase tracking-widest font-medium text-terracotta border border-terracotta/30"
            title="A Folio Edition"
          >
            <BadgeCheck className="w-3 h-3" strokeWidth={2} />
            Folio Edition
          </div>
        )}
        {purchasedCount > 0 && (
          <div
            data-testid={`badge-live-${book.id}`}
            className="absolute top-3 right-3 bg-terracotta text-paper px-2 py-1 flex items-center gap-1 text-[10px] uppercase tracking-widest font-medium shadow-[0_0_24px_rgba(217,108,74,0.55)] animate-pulse"
            title={`${purchasedCount} bought in the last day`}
          >
            <TrendingUp className="w-3 h-3" strokeWidth={2} />
            {purchasedCount} today
          </div>
        )}
        {book.external_url && (
          <div className="absolute bottom-3 right-3 bg-ink/85 text-paper px-2 py-1 text-[10px] uppercase tracking-widest font-medium">
            Classic
          </div>
        )}
      </div>
        <div className="mt-5">
          <div className="label-eyebrow text-sage">{book.category}</div>
          <h3 className="font-serif text-xl mt-1.5 leading-tight group-hover:text-terracotta transition-colors">
            {book.title}
          </h3>
          <div className="text-sm text-muted_ink mt-1">{book.author}</div>
          <div className="mt-3 font-sans text-sm font-medium">${book.price?.toFixed(2)}</div>
        </div>
      </Link>
    </div>
  );
}
